import React, { useState, useRef, useEffect } from 'react';
import { Calendar, ChevronDown, ExternalLink, Download } from 'lucide-react';
import { Button } from './ui/button';
import {
  generateGoogleCalendarUrl,
  generateOutlookCalendarUrl,
  generateYahooCalendarUrl,
  downloadICSFile
} from '../utils/calendar';

export default function AddToCalendar({ event, className = '' }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const calendarOptions = [
    {
      name: 'Google Calendar',
      icon: '📅',
      action: () => window.open(generateGoogleCalendarUrl(event), '_blank')
    },
    {
      name: 'Outlook',
      icon: '📧',
      action: () => window.open(generateOutlookCalendarUrl(event), '_blank')
    },
    {
      name: 'Yahoo Calendar',
      icon: '📆',
      action: () => window.open(generateYahooCalendarUrl(event), '_blank')
    },
    {
      name: 'Download .ics',
      icon: '⬇️',
      action: () => downloadICSFile(event)
    }
  ];

  return (
    <div className={`relative ${className}`} ref={dropdownRef}>
      <Button
        variant="outline"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2"
        data-testid="add-to-calendar-btn"
      >
        <Calendar className="w-4 h-4" />
        Add to Calendar
        <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </Button>

      {isOpen && (
        <div className="absolute top-full left-0 mt-2 w-56 bg-gray-900 border border-white/10 rounded-xl shadow-xl z-50 overflow-hidden">
          {calendarOptions.map((option, index) => (
            <button
              key={option.name}
              onClick={() => {
                option.action();
                setIsOpen(false);
              }}
              className="w-full px-4 py-3 flex items-center gap-3 hover:bg-white/5 transition-colors text-left"
              data-testid={`calendar-option-${index}`}
            >
              <span className="text-lg">{option.icon}</span>
              <span className="text-white/80">{option.name}</span>
              {option.name !== 'Download .ics' && (
                <ExternalLink className="w-3 h-3 text-white/40 ml-auto" />
              )}
              {option.name === 'Download .ics' && (
                <Download className="w-3 h-3 text-white/40 ml-auto" />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
